import { RefObject, useEffect, useState } from 'react'

export const useTableHeight = (
  headerRef: RefObject<HTMLElement | null>,
  defaultOffset: number = 120
): number => {
  const [offset, setOffset] = useState(defaultOffset)
  const [height, setHeight] = useState(window.innerHeight - defaultOffset)

  useEffect(() => {
    if (!headerRef.current) return
    const updateOffset = () => setOffset(headerRef.current!.offsetHeight)
    updateOffset()
    const observer = new window.ResizeObserver(updateOffset)
    observer.observe(headerRef.current)
    return () => observer.disconnect()
  }, [headerRef])

  useEffect(() => {
    // 120 is the header height
    const updateHeight = () => setHeight(window.innerHeight - offset - 120)
    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [offset])

  return height
}
